<div class="drawer-layout">
    <div class="drawer-content flex-row justify-content-space-between align-items-center">
      <div>
        Filter Alerts
      </div>
      <app-filter-button [appliedFiltersCount]="appliedFiltersCount"
                         [active]="showingFilterBar"
                         (toggled)="toggleFilter()"
      ></app-filter-button>
    </div>

    <div>
      <app-filter-bar
        [origin]="'alerts'"
        [showingFilterBar]="showingFilterBar"
        [useDateFilter]="true"
        (dateFilterChanged)="onDateFilterChanged($event)"
        [useVehicleFilter]="true"
        (vehicleFilterChanged)="onVehicleFilterChanged($event)"
        [useDriverFilter]="true"
        (driverFilterChanged)="onDriverFilterChanged($event)"
        (appliedFiltersChanged)="appliedFiltersCount = $event"
      >
      </app-filter-bar>
    </div>

	@if (items) {
		@for (item of items; track $index) {
			<div class="drawer-content">
				<app-card-menu-item
						[item]="item"
				></app-card-menu-item>
			</div>
		}

		@if (items.length === 0) {
			<div class="drawer-content">
				<span class="text-muted">There are no alerts for filter set.</span>
			</div>
		}
	}
</div>
